import React, { Component } from "react";
import {format, isPast} from "date-fns";
import { getDuration } from '~/tools/mll/helpers';
import './style.scss';

class Timer02 extends Component {
  state = {
    timeDiff: this.props.startDate - (new Date())
  };

  componentDidMount() {
    if(this.state.timeDiff > 0){
        this.timer = setInterval(() => {
          const currentTimeDiff = this.state.timeDiff - 1000;
          this.setState({ timeDiff: currentTimeDiff > 0 ? currentTimeDiff : 0 });
          
          if(this.state.timeDiff <= 0){
            clearInterval(this.timer);
            this.props.cb();
          }
        }, 1000);
    }
  }

  componentWillUnmount = () => {
    clearInterval(this.clock);
  };

  render() {
    const currentTimeDiff = getDuration(this.state.timeDiff);
    return <div className="timer02">
        <p>Starts in
            <span className="hour"> {`${currentTimeDiff.getHours()}h`}</span>
            <span className="minute"> {`${currentTimeDiff.getMinutes()}m`}</span>
            <span className="second"> {`${currentTimeDiff.getSeconds()}s`}</span>
        </p>
    </div>;
  }
}

export default Timer02;
